"use strict";

(function (global) {
  /**
   * Функции отвечающие за работу с задачами.
   * @namespace Core.tasks
   * @since 5.5.0.2201
   */
  global.tasks = {};
})(window.Core);

(function (global) {

  /**
   * Инициализация кнопки выбора ТМ в поле маршрута.
   * @since 5.5.0.1000
   */
  global.initSelectStandardRouteButton = function () {
    var jRoute = $('#CardContrrolRoute');
    if (jRoute.length === 0) {
      // Когда ТМ выбран будет другой контрол.
      jRoute = $('#CardContrrolStandartRoute');
    }
    jRoute = jRoute.closest('.reference_requisite');

    var jAdditionalIcons = jRoute.find('.Req_AdditionalIcons');

    var jSelectStandardRoute = $('<p class="task-card__select-standard-route" title="' + L('TASK_ROUTE_SELECT_STANDARD_ROUTE') + '"></p>');
    jSelectStandardRoute.on('click', function () {
      ChangeStandartRoute();
    });

    // Удаляем все иконки внутри, т.к. они бесполезны с данным справочником (ТМ).
    jAdditionalIcons.find('p').remove();

    // Добавляем новую иконку для выбор ТМ.
    jAdditionalIcons
      .append(jSelectStandardRoute)
      .show();

    return global;
  };

  /**
   * Установить доступность кнопок на ленте для задач.
   * @since 5.5.0.2201
   */
  global.bindButtonsEnabling = function () {
    if (!WA.CR.IsNew) {
      var toolBarButtons = WA.CR.toolBar.buttons;
      var isBindNeeded = !(toolBarButtons.isExist('TaskChange') && !toolBarButtons.TaskChange.isSelected());
      if (isBindNeeded) {
        window.Core.customWorks.bindButtonsEnabling('textarea.Card_Task_EditText');

        var toolBarButtonNames = ['TaskHighImp', 'TaskLowImp'];
        var enableButtonNames = ['Save'];
        toolBarButtonNames.forEach(function (buttonName) {
          var toolBarButton = toolBarButtons[buttonName];
          if (toolBarButton) {
            toolBarButton.bind('click', function () {
              Core.cards.enableButtonsOnFormChange(enableButtonNames);
            });
          }
        });

        $(".Card_Table_Container").find('input').one('change keypress',function () {
          Core.cards.enableButtonsOnFormChange(enableButtonNames);
        });
      }
    }

    return global;
  };

})(window.Core.tasks);